import React from 'react'
import ButtonModalClose from '../../elements/ButtonModalClose'

const ModalAddBookingServeurClient = ({ dataBooking, _converteTimeToHours, _handleAddBooking, services, choiceService, setChoiceService, _refreshModal }) => {
    return (
        <div className="modal fade" id="modalAddBookingServeurClient" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> 
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Faire un réservation</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={_refreshModal}></button>
                    </div>
                    <div className="modal-body">  
                    
                        <div className='text-center h5'>{dataBooking.dateShow} à {_converteTimeToHours(dataBooking.hours)}</div>

                        <div className='mt-4' />

                        {/* SERVICES */}
                        {choiceService.nameService ? 
                            <>
                                <div className='row'>
                                    <div className='col'>{_converteTimeToHours(dataBooking.hours)} {choiceService.nameService} {choiceService.priceService}€ {choiceService.durationService}min</div>
                                    <div className='col-2 text-danger text-center fw-bold' onClick={() => setChoiceService([])}>X</div>
                                </div> 
                            </>
                        : 
                            <>
                                {services.filter(l => l.doc === 'docList').map(l => (
                                    <div className='mb-3'>

                                        {/* LISTE */}
                                        <div 
                                            key={l.id} 
                                            className='text-center rounded-top p-2 border-bottom'
                                            style={{ backgroundColor:'lightgrey' }}
                                        >{l.nameList}</div>

                                        {/* SERVICES */}
                                        {services
                                            .filter(s => s.nameList === l.nameList && s.doc === 'docService')
                                            .sort((a,b) => a.nameService > b.nameService ? 1 : -1)
                                            .map(s => (
                                            <div className='p-2 border-bottom border-start border-end'>
                                                <div 
                                                    key={s.id}
                                                    onClick={() => setChoiceService({
                                                                        idService:s.id, 
                                                                        nameService:s.nameService, 
                                                                        priceService:s.priceService, 
                                                                        durationService:s.durationService
                                                    })}
                                                >{s.nameService}</div>
                                            </div>
                                        ))}

                                    </div>
                                ))} 
                            </>
                        } 

                        {/* BUTTON SAVE */}
                        <ButtonModalClose
                            onClick={() => _handleAddBooking(
                                dataBooking.date,
                                dataBooking.dateInt,
                                dataBooking.dateShow,
                                dataBooking.hours,
                                dataBooking.idStaff,
                                dataBooking.surnameStaff,
                                dataBooking.nameStaff,
                            )}
                            disabled={choiceService.nameService ? false : true}
                            title='Ajouter'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAddBookingServeurClient